// extracted by mini-css-extract-plugin
export default {"datastat":"StatusTag_datastat__qKGmt","hover":"StatusTag_hover__zXXLw","white":"StatusTag_white__bXEIA"};